import moment from 'moment';
import 'moment/min/locales';

export const formatDate = (value, langCode) => {
  const dateFormatOptions = {
    month: 'short', day: 'numeric', year: 'numeric'
  }
  return new Intl.DateTimeFormat(langCode || 'en', dateFormatOptions).format(new Date(value));
}

export const formatChartDate = (date, dateFormatOptions, langCode) => new Intl.DateTimeFormat(langCode === 'en' ? 'en-GB' : langCode, dateFormatOptions).format(date)

export const getEndDate =()=>{
  const nextMonth = moment().add(1, 'months');
  const endDate= moment(nextMonth).endOf('months');
  return endDate;
}

